// File to store and manage constants related to feature flags currently employed in weaver/pear.md
// To be used to control the display of the Kakariko Library components being rendered on the Manage* pages.
export const KAKARIKO_SCREENS = 'kakariko-981121';
